/*jslint browser: true, evil: true */

// define correct path for files inclusion
var scripts = document.getElementsByTagName('script'),
    path = scripts[scripts.length - 1].src.split('?')[0],
    tarteaucitronForceCDN = (tarteaucitronForceCDN === undefined) ? '' : tarteaucitronForceCDN,
    cdn = (tarteaucitronForceCDN === '') ? path.split('/').slice(0, -1).join('/') + '/' : tarteaucitronForceCDN,
    alreadyLaunch = (alreadyLaunch === undefined) ? 0 : alreadyLaunch,
    tarteaucitronForceLanguage = (tarteaucitronForceLanguage === undefined) ? '' : tarteaucitronForceLanguage,
    tarteaucitronForceExpire = (tarteaucitronForceExpire === undefined) ? '' : tarteaucitronForceExpire,
    tarteaucitronCustomText = (tarteaucitronCustomText === undefined) ? '' : tarteaucitronCustomText,
    timeExipre = 31536000000,
    tarteaucitronProLoadServices,
    tarteaucitronNoAdBlocker = false;


var tarteaucitron = {
    "version": 20181023,
    "cdn": cdn,
    "user": {},
    "lang": {},
    "services": {},
    "added": [],
    "idprocessed": [],
    "state": [],
    "launch": [],
    "parameters": {},
    "isAjax": false,
    "reloadThePage": false,
    "contentsquare": "",
    "googlemaps": "",
    "googletagmanager": "",
    "googleadwordsremarketing": "",
    "allAllowed": "",
    "events": {
        "init": function () {

        },
        "load": function () {
        },
    },
    "init": function (params) {
        "use strict";
        var origOpen;
        console.log("tarte au citron init ");
        tarteaucitron.parameters = params;

        if (alreadyLaunch === 0) {
            alreadyLaunch = 1;
            if (window.addEventListener) {
                window.addEventListener("load", function () {
                    tarteaucitron.load();
                    tarteaucitron.fallback(['tarteaucitronOpenPanel'], function (elem) {
                        elem.addEventListener("click", function (event) {
                            tarteaucitron.userInterface.openPanel();
                            event.preventDefault();
                        }, false);
                    }, true);
                }, false);
                window.addEventListener("scroll", function () {
                    var scrollPos = window.pageYOffset || document.documentElement.scrollTop,
                        heightPosition;
                    if (document.getElementById('tarteaucitronAlertBig') !== null && !tarteaucitron.highPrivacy) {
                        if (document.getElementById('tarteaucitronAlertBig').style.display === 'block') {
                            heightPosition = document.getElementById('tarteaucitronAlertBig').offsetHeight + 'px';

                            if (scrollPos > (screen.height * 2)) {
                                tarteaucitron.userInterface.respondAll(true);
                            } else if (scrollPos > (screen.height / 2)) {
                                document.getElementById('tarteaucitronDisclaimerAlert').innerHTML = '<strong>' + tarteaucitron.lang.alertBigScroll + '</strong> ' + tarteaucitron.lang.alertBig;
                            }

                            if (tarteaucitron.orientation === 'top') {
                                document.getElementById('tarteaucitronPercentage').style.top = heightPosition;
                            } else {
                                document.getElementById('tarteaucitronPercentage').style.bottom = heightPosition;
                            }
                            document.getElementById('tarteaucitronPercentage').style.width = ((100 / (screen.height * 2)) * scrollPos) + '%';
                        }
                    }
                }, false);


                window.addEventListener("hashchange", function () {
                    if (document.location.hash === tarteaucitron.hashtag && tarteaucitron.hashtag !== '') {
                        tarteaucitron.userInterface.openPanel();
                    }
                }, false);
                window.addEventListener("resize", function () {
                    if (document.getElementById('tarteaucitron') !== null) {
                        if (document.getElementById('tarteaucitron').style.display === 'block') {
                            tarteaucitron.userInterface.jsSizing('main');
                        }
                    }

                    if (document.getElementById('tarteaucitronCookiesListContainer') !== null) {
                        if (document.getElementById('tarteaucitronCookiesListContainer').style.display === 'block') {
                            tarteaucitron.userInterface.jsSizing('cookie');
                        }
                    }
                }, false);
            } else {
                window.attachEvent("onload", function () {
                    tarteaucitron.load();
                    tarteaucitron.fallback(['tarteaucitronOpenPanel'], function (elem) {
                        elem.attachEvent("onclick", function (event) {
                            tarteaucitron.userInterface.openPanel();
                            event.preventDefault();
                        });
                    }, true);
                });
                window.attachEvent("onscroll", function () {
                    var scrollPos = window.pageYOffset || document.documentElement.scrollTop,
                        heightPosition;
                    if (document.getElementById('tarteaucitronAlertBig') !== null && !tarteaucitron.highPrivacy) {
                        if (document.getElementById('tarteaucitronAlertBig').style.display === 'block') {
                            heightPosition = document.getElementById('tarteaucitronAlertBig').offsetHeight + 'px';

                            if (scrollPos > (screen.height * 2)) {
                                tarteaucitron.userInterface.respondAll(true);
                            } else if (scrollPos > (screen.height / 2)) {
                                document.getElementById('tarteaucitronDisclaimerAlert').innerHTML = '<strong>' + tarteaucitron.lang.alertBigScroll + '</strong> ' + tarteaucitron.lang.alertBig;
                            }
                            if (tarteaucitron.orientation === 'top') {
                                document.getElementById('tarteaucitronPercentage').style.top = heightPosition;
                            } else {
                                document.getElementById('tarteaucitronPercentage').style.bottom = heightPosition;
                            }
                            document.getElementById('tarteaucitronPercentage').style.width = ((100 / (screen.height * 2)) * scrollPos) + '%';
                        }
                    }
                });
                window.attachEvent("onkeydown", function (evt) {

                    if (evt.keyCode === 9 && focusableEls.indexOf(evt.target) >= 0) {
                        if (evt.shiftKey) /* shift + tab */ {
                            if (document.activeElement === firstFocusableEl) {
                                lastFocusableEl.focus();
                                evt.preventDefault();
                            }
                        } else /* tab */ {
                            if (document.activeElement === lastFocusableEl) {
                                firstFocusableEl.focus();
                                evt.preventDefault();
                            }
                        }
                    }

                });
                window.attachEvent("onhashchange", function () {
                    if (document.location.hash === tarteaucitron.hashtag && tarteaucitron.hashtag !== '') {
                        tarteaucitron.userInterface.openPanel();
                    }
                });
                window.attachEvent("onresize", function () {
                    if (document.getElementById('tarteaucitron') !== null) {
                        if (document.getElementById('tarteaucitron').style.display === 'block') {
                            tarteaucitron.userInterface.jsSizing('main');
                        }
                    }

                    if (document.getElementById('tarteaucitronCookiesListContainer') !== null) {
                        if (document.getElementById('tarteaucitronCookiesListContainer').style.display === 'block') {
                            tarteaucitron.userInterface.jsSizing('cookie');
                        }
                    }
                });
            }

            if (typeof XMLHttpRequest !== 'undefined') {
                origOpen = XMLHttpRequest.prototype.open;
                XMLHttpRequest.prototype.open = function () {

                    if (window.addEventListener) {
                        this.addEventListener("load", function () {
                            if (typeof tarteaucitronProLoadServices === 'function') {
                                tarteaucitronProLoadServices();
                            }
                        }, false);
                    } else if (typeof this.attachEvent !== 'undefined') {
                        this.attachEvent("onload", function () {
                            if (typeof tarteaucitronProLoadServices === 'function') {
                                tarteaucitronProLoadServices();
                            }
                        });
                    } else {
                        if (typeof tarteaucitronProLoadServices === 'function') {
                            setTimeout(tarteaucitronProLoadServices, 1000);
                        }
                    }

                    try {
                        origOpen.apply(this, arguments);
                    } catch (err) {
                    }
                };
            }
        }

        if (tarteaucitron.events.init) {
            tarteaucitron.events.init();
        }


    },
    "load": function () {
        "use strict";
        var cdn = tarteaucitron.cdn,
            language = tarteaucitron.getLanguage(),
            pathToLang = cdn + 'lang/tarteaucitron.' + language + '.js?v=' + tarteaucitron.version,
            pathToServices = cdn + 'tarteaucitron.services.js?v=' + tarteaucitron.version,
            linkElement = document.createElement('link'),
            defaults = {
                "adblocker": false,
                "hashtag": '#tarteaucitron',
                "cookieName": 'tarteaucitron',
                "highPrivacy": false,
                "orientation": "top",
                "removeCredit": false,
                "showAlertSmall": true,
                "cookieslist": true,
                "handleBrowserDNTRequest": false,
                "AcceptAllCta": false,
                "moreInfoLink": true,
                "privacyUrl": "",
                "useExternalCss": false
            },
            params = tarteaucitron.parameters;
        console.log("tarte au citron load ");
        // Step 0: get params
        if (params !== undefined) {

            for (var k in defaults) {
                if (!tarteaucitron.parameters.hasOwnProperty(k)) {
                    tarteaucitron.parameters[k] = defaults[k];
                }
            }
        }

        // global
        tarteaucitron.orientation = tarteaucitron.parameters.orientation;
        tarteaucitron.hashtag = tarteaucitron.parameters.hashtag;
        tarteaucitron.highPrivacy = tarteaucitron.parameters.highPrivacy;
        tarteaucitron.handleBrowserDNTRequest = tarteaucitron.parameters.handleBrowserDNTRequest;


        // Step 1: load css
        if (!tarteaucitron.parameters.useExternalCss) {
            linkElement.rel = 'stylesheet';
            linkElement.type = 'text/css';
            linkElement.href = cdn + 'css/tarteaucitron.css?v=' + tarteaucitron.version;
            document.getElementsByTagName('head')[0].appendChild(linkElement);
        }
        // Step 2: load language and services
        tarteaucitron.addScript(pathToLang, '', function () {

            if (tarteaucitronCustomText !== '') {
                tarteaucitron.lang = tarteaucitron.AddOrUpdate(tarteaucitron.lang, tarteaucitronCustomText);
            }
            tarteaucitron.addScript(pathToServices, '', function () {

                var body = document.body,
                    div = document.createElement('div'),
                    html = '',
                    index,
                    orientation = 'Top',
                    cat = ['ads', 'analytic', 'api', 'comment', 'social', 'support', 'video', 'other'],
                    i;

                cat = cat.sort(function (a, b) {
                    if (tarteaucitron.lang[a].title > tarteaucitron.lang[b].title) {
                        return 1;
                    }
                    if (tarteaucitron.lang[a].title < tarteaucitron.lang[b].title) {
                        return -1;
                    }
                    return 0;
                });

                // Step 3: prepare the html
                html += '<div id="tarteaucitronPremium"></div>';
                html += '<div id="tarteaucitronBack" aria-label="' + tarteaucitron.lang.close + '"></div>';
                html += '<div id="tarteaucitron"  class="33 amds-modal container-fluid tarteaucitronAlertBigMiddle " role="dialog" aria-labelledby="dialogTitle">';

                html += '   <div id="tarteaucitronServices">';
                html += '<div class="header d-flex">';
                html +=`<svg class="logo" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="svg2" x="0px" y="0px" viewBox="0 0 1122.5 453.5" style="enable-background:new 0 0 1122.5 453.5;" xml:space="preserve">
                    <style type="text/css">
            .st0{clip-path:url(#SVGID_2_);}
            .st1{fill:#F03B26;}
            .st2{fill:#393536;}
            .st36{fill:url(#SVGID_3_6);}
            </style>
                <g id="g10" transform="matrix(1.3333333,0,0,-1.3333333,0,453.54267)">
                    <g id="g12">
                    <g>
                    <defs>
                    <rect id="SVGID_1_" x="139" y="128.1" width="571.7" height="231"></rect>
                    </defs>
                    <clipPath id="SVGID_2_">
                    <use xlink:href="#SVGID_1_" style="overflow:visible;"></use>
                    </clipPath>
                    <g id="g14" class="st0">
                    <g id="g20" transform="translate(779.7754,198.3157)">
                    <path id="path22" class="st1" d="M-172.2,59.6c-2.2,0-4.4,0.8-5.7,1.4c-25.7,13.4-54.8,21.3-83.1,21.3c-3.5,0-6.2-0.1-9.5-0.5       c5.3-8.5,14.5-20.8,20.8-28.4c1.6-2,2.1-3.1,2.1-5c0-3.3-3.5-6.5-7.2-6.5c-2.5,0-3.9,1-6.2,3.7c-7.7,9-19.2,24.9-24.6,34       C-312.4,74.8-342.3,59-360,45c-2-1.6-3.4-2.3-5.5-2.3c-3.8,0-7,3.2-7,6.9c0,2.1,0.8,3.8,3.6,6.1c27,22.5,68.9,40.2,104.5,40.2       c14.1,0,27.7-2,40.9-5.2c8-2,19.8-5.9,29.9-10.3c-26.5,16-59.7,30.6-80.6,30.6c-5.4,0-8.6-1.8-8.6-5.4c0-2.1,1.2-5,2.9-7.8       c-4.2-0.4-9.7-1.3-13.9-2.4c-2.2,4-3.7,8.3-3.7,12.9c0,10.2,6.7,16.5,20.1,16.5c30.4,0,81.5-28.3,107-49.1       c2.9-2.4,5.8-5.3,5.8-8.8C-164.6,63.6-167.5,59.6-172.2,59.6"></path>
                    </g>
                    <g id="g24" transform="translate(130.7725,79.8913)">
                    <path id="path26" class="st2" d="M146.2,117.7c0,1.8,1.1,3,2.8,3c1.7,0,2.8-1.1,2.8-3v-3.1c1.5,3,4.8,6,7.7,6       c1.9,0,2.8-1.1,2.8-2.6c0-1.4-0.8-2.5-3.2-3.2c-5.1-1.4-7.3-4.2-7.3-9.7V89.4c0-1.8-1.1-3-2.8-3c-1.7,0-2.8,1.1-2.8,3V117.7z"></path>
                    </g>
                    <g id="g28" transform="translate(375.7041,79.8913)">
                    <path id="path30" class="st2" d="M26.1,117.7c0,1.8,1.1,3,2.8,3c1.7,0,2.8-1.1,2.8-3v-3.1c1.5,3,4.8,6,7.7,6       c1.9,0,2.8-1.1,2.8-2.6c0-1.4-0.8-2.5-3.2-3.2c-5.1-1.4-7.3-4.2-7.3-9.7V89.4c0-1.8-1.1-3-2.8-3c-1.7,0-2.8,1.1-2.8,3V117.7z"></path>
                    </g>
                    <g id="g32" transform="translate(193.4937,85.6941)">
                    <path id="path34" class="st2" d="M115.5,114.9c5.4,0,8.9-2.2,8.9-4.1c0-1.2-0.9-2.3-2.2-2.3c-2,0-3,1.6-6.7,1.6       c-6.3,0-9.6-5.7-9.6-12.3c0-7.2,3.7-12.3,9.6-12.3c4.1,0,5,1.7,7,1.7c1.3,0,2-0.8,2-2.2c0-1.3-1-2.3-2.9-3.1       c-1.6-0.8-3.8-1.2-6.1-1.2c-9.5,0-15.1,7.1-15.1,17.1C100.3,107.6,106.1,114.9,115.5,114.9"></path>
                    </g>
                    <g id="g36" transform="translate(262.8223,56.0671)">
                    <path id="path38" class="st2" d="M81.4,129.4c0,4.8-2.7,10.2-8.8,10.2c-6,0-9.2-4.7-9.4-10.2H81.4z M63.2,125.3       c0.1-5.5,3.6-10.1,9.9-10.1c6.5,0,8.1,3.7,10.4,3.7c1.3,0,2.3-0.9,2.3-2.3c0-2.7-6-6.2-12.7-6.2c-5,0-8.4,1.6-10.9,4.1       c-3.2,3.2-4.7,8-4.7,13c0,9.1,5.7,17.1,15,17.1c8.7,0,14.4-7.7,14.4-16.3c0-1.9-0.8-3-3.1-3H63.2z"></path>
                    </g>
                    <g id="g40" transform="translate(296.1406,24.3435)">
                    <path id="path42" class="st2" d="M65.1,145c0-1.8-1.1-3-2.8-3c-1.7,0-2.8,1.1-2.8,3v39.6c0,1.8,1.1,3,2.8,3       c1.7,0,2.8-1.1,2.8-3V145z"></path>
                    </g>
                    <g id="g44" transform="translate(335.9043,28.0583)">
                    <path id="path46" class="st2" d="M45.6,143.2c5.4,0,9.1,4.7,9.1,12.3c0,7.5-3.7,12.3-9.1,12.3s-9.1-4.7-9.1-12.3       C36.4,147.9,40.2,143.2,45.6,143.2 M45.6,138.3c-8.8,0-14.7,7.1-14.7,17.1c0,10.1,5.9,17.1,14.7,17.1s14.7-7.1,14.7-17.1       C60.3,145.4,54.4,138.3,45.6,138.3"></path>
                    </g>
                    <g id="g48" transform="translate(483.1455,81.1618)">
                    <path id="path50" class="st2" d="M-26.7,117.1c-3.1-10.7-8.2-28.2-8.6-29.6c-0.5-1.6-1.4-2.3-3-2.3c-1.5,0-2.5,0.6-3,2.3       c-0.4,1.5-5.8,19.9-8.8,30.4c-0.5,1.7-1,3.8-1.3,5.5c-0.2-1.7-0.5-3.7-0.8-5.6c-1.6-10-4.1-25.5-4.7-29.9       c-0.3-1.9-1.3-2.8-2.9-2.8c-1.5,0-2.5,1-2.5,2.6c0,0.6,0.1,1.4,0.3,2.5c0,0,5.6,33.6,6,36.2c0.5,2.7,1.9,4.2,4.2,4.2       c2.1,0,3.7-1.2,4.3-3.5c0.4-1.4,4.9-17.2,7.8-27.2c0.5-1.8,1.1-4,1.5-6c0.4,1.9,0.9,4,1.4,5.8c2.9,10,7.4,25.9,7.9,27.3       c0.7,2.3,2.1,3.5,4.2,3.5c2.2,0,3.8-1.4,4.2-4.2c0.4-2.6,6-36.2,6-36.2c0.2-1.1,0.3-1.9,0.3-2.5c0-1.6-1-2.6-2.5-2.6       c-1.6,0-2.6,0.8-2.9,2.8c-0.7,4.3-3,19.1-4.6,29c-0.3,2-0.6,4.3-0.9,6.5C-25.5,121.6-26,119.4-26.7,117.1"></path>
                    </g>
                    <g id="g52" transform="translate(532.3252,79.8913)">
                    <path id="path54" class="st2" d="M-50.8,117.7c0,1.8-1.1,3-2.8,3c-1.7,0-2.8-1.1-2.8-3V89.4c0-1.8,1.1-3,2.8-3       c1.7,0,2.8,1.1,2.8,3V117.7z M-53.6,130.5c1.9,0,3.4-1.5,3.4-3.4c0-1.9-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4       C-57,129-55.5,130.5-53.6,130.5"></path>
                    </g>
                    <g id="g56" transform="translate(551.3242,99.1482)">
                    <path id="path58" class="st2" d="M-60.1,108.3c0,1.8,1.1,3,2.8,3s2.8-1.1,2.8-3V101h2.3c1.8,0,2.8-0.9,2.8-2.4       c0-1.5-0.9-2.4-2.8-2.4h-2.3V70.2c0-1.8-1.1-3-2.8-3s-2.8,1.1-2.8,3v26.1h-2c-1.8,0-2.8,0.9-2.8,2.4c0,1.5,0.9,2.4,2.8,2.4h2       V108.3z"></path>
                    </g>
                    <g id="g60" transform="translate(585.7764,99.1482)">
                    <path id="path62" class="st2" d="M-77,108.3c0,1.8,1.1,3,2.8,3c1.7,0,2.8-1.1,2.8-3V101h2.3c1.8,0,2.8-0.9,2.8-2.4       c0-1.5-0.9-2.4-2.8-2.4h-2.3V70.2c0-1.8-1.1-3-2.8-3c-1.7,0-2.8,1.1-2.8,3v26.1h-2c-1.8,0-2.8,0.9-2.8,2.4       c0,1.5,0.9,2.4,2.8,2.4h2V108.3z"></path>
                    </g>
                    <g id="g64" transform="translate(68.4829,53.073)">
                    <path id="path66" class="st2" d="M176.8,130.9c2.3,6.5,4.8,13.5,6.5,18.3c0.5,1.3,0.9,2.6,1.2,3.6c0.3-1.1,0.8-2.4,1.2-3.6       c1.7-4.7,4.2-11.8,6.5-18.3H176.8z M202.6,118.4c-1.2,3.1-12,32.3-13.7,36.8c-0.8,2.3-2.1,3.6-4.3,3.6c-2.2,0-3.4-1.3-4.2-3.6       c-0.8-2-12.6-33.7-13.8-36.8c-0.5-1.4-0.7-2.1-0.7-2.7c0-1.4,1.2-2.4,2.6-2.4c1.5,0,2.4,0.8,2.8,2.1c0.3,0.8,1.8,5.1,3.8,10.6       h19c1.9-5.2,3.3-9.4,3.8-10.6c0.4-1.2,1.2-2.1,2.7-2.1c1.4,0,2.8,0.9,2.8,2.3C203.3,116.3,203.2,116.8,202.6,118.4"></path>
                    </g>
                    <g id="g68" transform="translate(695.8213,24.3435)">
                    <path id="path70" class="st2" d="M-131,145c0-1.8-1.1-3-2.8-3c-1.7,0-2.8,1.1-2.8,3v39.6c0,1.8,1.1,3,2.8,3       c1.7,0,2.8-1.1,2.8-3V145z"></path>
                    </g>
                    <g id="g72" transform="translate(640.6777,28.0437)">
                    <path id="path74" class="st2" d="M-104,143.2c-5.4,0-9.1,4.7-9.1,12.3c0,7.5,3.7,12.3,9.1,12.3c5.4,0,9.1-4.7,9.1-12.3       C-94.8,147.9-98.5,143.2-104,143.2 M-92.1,172.5c-1.7,0-2.8-1.1-2.8-3v-2.5c-2.1,3.4-5.4,5.5-9.5,5.5       c-8.5,0-14.3-7.1-14.3-17.1c0-10.1,5.8-17.1,14.3-17.1c4.1,0,7.5,2.1,9.5,5.5v-2.5c0-1.8,1.1-3,2.8-3c1.7,0,2.8,1.1,2.8,3v28.3       C-89.3,171.4-90.4,172.5-92.1,172.5"></path>
                    </g>
                    </g>
                    </g>
                    </g>
                    </g>
                    <linearGradient id="SVGID_3_6" gradientUnits="userSpaceOnUse" x1="310.0313" y1="349.0398" x2="794.6602" y2="349.0398">
                    <stop offset="0" style="stop-color:#696969"></stop>
                    <stop offset="0.6364" style="stop-color:#C74A27"></stop>
                    <stop offset="1" style="stop-color:#FF3700"></stop>
                    </linearGradient>
                    <path class="st36" d="M383.2,375.9h-59.2c0.5,9.3,3.4,17,8.9,23.2c5.4,6.1,12,9.2,19.5,9.2c3.9,0,7.9-0.6,11.8-1.9  c4-1.3,8.4-4.1,13.3-8.5c3.2-2.9,5.5-4.3,6.9-4.3c4,0,6.1,2.1,6.1,6.3c0,3.6-3.7,7.7-11.1,12.3c-7.4,4.6-16.1,6.9-26.2,6.9  c-13.5,0-24.1-4.6-31.8-13.8c-7.7-9.2-11.5-20.9-11.5-35.1c0-13.5,3.8-25,11.4-34.6c7.6-9.6,17.5-14.4,29.8-14.4  c12.4,0,22.3,4.5,29.7,13.4c7.4,8.9,11.2,20.1,11.2,33.4C392.1,373.3,389.2,375.9,383.2,375.9z M324.1,365.1h54  c-0.5-9.7-3.2-17.7-8.2-23.9c-5-6.2-11.3-9.3-18.8-9.3c-7.6,0-13.9,3.1-18.9,9.3C327.3,347.4,324.6,355.4,324.1,365.1z M410.7,364.2  h34.9c2,0,3.6,0.6,4.9,1.7c1.3,1.1,1.9,2.5,1.9,4.2c0,1.7-0.6,3.1-1.9,4.3c-1.3,1.1-2.9,1.7-4.9,1.7h-34.9c-2,0-3.6-0.6-4.9-1.7  c-1.3-1.1-1.9-2.6-1.9-4.3c0-1.6,0.6-3,1.9-4.2C407,364.8,408.7,364.2,410.7,364.2z M467.7,346.4c0-7.4,3.1-13.5,9.2-18.2  c6.1-4.7,13.1-7,20.9-7c9,0,16.8,1.6,23.6,4.7c6.8,3.1,10.2,6.5,10.2,10.1c0,4.2-2.2,6.3-6.5,6.3c-1.3,0-3.5-1.1-6.8-3.4  c-6.6-4.6-12.5-6.9-17.8-6.9c-5.2,0-9.6,1.2-13.3,3.7c-3.6,2.5-5.4,5.7-5.4,9.8c0,2.4,0.7,4.6,2.2,6.5c1.4,2,3.6,3.5,6.5,4.7l19.7,8  c9.4,3.8,15.8,7.7,19.1,11.9c3.3,4.2,4.9,9.1,4.9,14.7c0,8.2-3.3,14.9-9.9,20c-6.6,5.1-15.1,7.7-25.4,7.7c-9.4,0-17.5-2.1-24.3-6.4  c-6.8-4.2-10.2-8.2-10.2-11.8c0-1.1,0.7-2.4,2-4c1.3-1.5,2.7-2.3,4.2-2.3c1.5,0,4,1.4,7.4,4.3c4.6,3.9,8.6,6.5,11.9,7.6  c3.3,1.1,6.5,1.7,9.7,1.7c6,0,11-1.6,14.9-4.7c3.9-3.1,5.8-7,5.8-11.6c0-3.3-1-6-2.9-8.3c-1.9-2.3-5-4.2-9.2-5.9l-23.5-9.7  c-6-2.5-10.3-5.4-12.9-8.9C469,355.6,467.7,351.4,467.7,346.4z M567.7,333v77.8c0,5.5-2.1,8.3-6.4,8.3c-4.3,0-6.5-2.8-6.5-8.3V333  h-8.4c-1.8,0-3.2-0.5-4.2-1.6s-1.5-2.3-1.5-3.8c0-1.5,0.5-2.8,1.5-3.9s2.4-1.6,4.2-1.6h8.4v-21c0-5.6,2.2-8.4,6.5-8.4  c4.3,0,6.4,2.8,6.4,8.4v21h8.5c1.8,0,3.1,0.5,4.1,1.6s1.5,2.3,1.5,3.9c0,1.5-0.5,2.7-1.5,3.8s-2.3,1.6-4.1,1.6H567.7z M663.2,375.9  H604c0.5,9.3,3.4,17,8.9,23.2c5.4,6.1,12,9.2,19.5,9.2c3.9,0,7.9-0.6,11.8-1.9c4-1.3,8.4-4.1,13.3-8.5c3.2-2.9,5.5-4.3,6.9-4.3  c4,0,6.1,2.1,6.1,6.3c0,3.6-3.7,7.7-11.1,12.3c-7.4,4.6-16.1,6.9-26.2,6.9c-13.5,0-24.1-4.6-31.8-13.8c-7.7-9.2-11.5-20.9-11.5-35.1  c0-13.5,3.8-25,11.4-34.6c7.6-9.6,17.5-14.4,29.8-14.4c12.4,0,22.3,4.5,29.7,13.4c7.4,8.9,11.2,20.1,11.2,33.4  C672.1,373.3,669.1,375.9,663.2,375.9z M604,365.1h54c-0.5-9.7-3.2-17.7-8.2-23.9c-5-6.2-11.3-9.3-18.8-9.3  c-7.6,0-13.9,3.1-18.9,9.3C607.2,347.4,604.5,355.4,604,365.1z M756.6,375.9h-59.2c0.5,9.3,3.4,17,8.9,23.2c5.4,6.1,12,9.2,19.5,9.2  c3.9,0,7.9-0.6,11.8-1.9c4-1.3,8.4-4.1,13.3-8.5c3.2-2.9,5.5-4.3,6.9-4.3c4,0,6.1,2.1,6.1,6.3c0,3.6-3.7,7.7-11.1,12.3  c-7.4,4.6-16.1,6.9-26.2,6.9c-13.5,0-24.1-4.6-31.8-13.8c-7.7-9.2-11.5-20.9-11.5-35.1c0-13.5,3.8-25,11.4-34.6  c7.6-9.6,17.5-14.4,29.8-14.4c12.4,0,22.3,4.5,29.7,13.4c7.4,8.9,11.2,20.1,11.2,33.4C765.5,373.3,762.5,375.9,756.6,375.9z   M697.5,365.1h54c-0.5-9.7-3.2-17.7-8.2-23.9c-5-6.2-11.3-9.3-18.8-9.3c-7.6,0-13.9,3.1-18.9,9.3  C700.6,347.4,697.9,355.4,697.5,365.1z M794.7,287.3v123.5c0,5.5-2.2,8.3-6.5,8.3c-4.3,0-6.5-2.8-6.5-8.3V287.3  c0-5.5,2.2-8.3,6.5-8.3C792.5,279,794.7,281.8,794.7,287.3z"></path>
                    </svg>`;
                html +=  '</div>';

                html += ' <h3 id="cookiesTitle" role="heading" aria-level="h1" id="dialogTitle">' + tarteaucitron.lang.title + '</h3>';
                html += '      <div class="tarteaucitronBorder">';
                html += '         <div class="clear"></div><div>';
                for (i = 0; i < cat.length; i += 1) {
                    html += '         <div id="tarteaucitronServicesTitle_' + cat[i] + '" class="tarteaucitronHidden">';
                    html += '         <ul id="tarteaucitronServices_' + cat[i] + '"></ul></div>';
                }
                html += '         </div>';

                html += '   <div class="wrapper">';
                html += '   <button class="btn-amds btn btn-primary amds-btn-secondary" onclick="tarteaucitron.userInterface.acceptSelectedOptions();">';
                html += '		<span>	' + tarteaucitron.lang.validateSelection;
                html += '  </span> <svg viewBox="0 0 33 14" xmlns="http://www.w3.org/2000/svg" aria-labelledby="Long Arrow"\n' +
                    '                         role="presentation" class="svg-icon"><title id="Long Arrow" lang="en">Long Arrow\n' +
                    '                        icon</title>\n' +
                    '                        <polygon\n' +
                    '                            points="25.1604773 0 32.6352213 6.85610681 25.1993812 13.7359725 24.3690601 12.8391022 30.1441884 7.49516092 0.0024154589 7.43569437 0 6.21588761 30.2001884 6.27516092 24.3378796 0.897439017"\n' +
                    '                            stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd"></polygon>\n' +
                    '                    </svg></button>';
                html += '   <button class="btn-amds btn btn-primary" onclick="tarteaucitron.userInterface.acceptAllOptions();">';
                html += '		<span>	' + tarteaucitron.lang.acceptAllOptions;
                html += '   </span><svg viewBox="0 0 33 14" xmlns="http://www.w3.org/2000/svg" aria-labelledby="Long Arrow"\n' +
                    '                         role="presentation" class="svg-icon"><title id="Long Arrow" lang="en">Long Arrow\n' +
                    '                        icon</title>\n' +
                    '                        <polygon\n' +
                    '                            points="25.1604773 0 32.6352213 6.85610681 25.1993812 13.7359725 24.3690601 12.8391022 30.1441884 7.49516092 0.0024154589 7.43569437 0 6.21588761 30.2001884 6.27516092 24.3378796 0.897439017"\n' +
                    '                            stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd"></polygon>\n' +
                    '                    </svg></button>';
                html += '   </div>';

                html += '         <div class="tarteaucitronHidden" id="tarteaucitronScrollbarChild"></div>';
                if (tarteaucitron.parameters.removeCredit === false) {
                    html += '     <a class="tarteaucitronSelfLink" href="https://opt-out.ferank.eu/" rel="nofollow" target="_blank" rel="noopener" title="tarteaucitron ' + tarteaucitron.lang.newWindow + '">🍋 ' + tarteaucitron.lang.credit + '</a>';
                }
                html += '       </div>';
                html += '   </div>';
                html += '</div>';

                if (tarteaucitron.parameters.orientation === 'bottom') {
                    orientation = 'Bottom';
                }

                if (tarteaucitron.parameters.orientation === 'middle') {
                    orientation = 'Middle';
                }

                if (tarteaucitron.parameters.highPrivacy && !tarteaucitron.parameters.AcceptAllCta) {
                    html += '<div id="tarteaucitronAlertBig" class="1 amds-modal tarteaucitronAlertBig' + orientation + '">';
                    html += '   <span id="tarteaucitronDisclaimerAlert" class="btn-amds btn btn-primary" >';
                    html += '       ' + tarteaucitron.lang.alertBigPrivacy;
                    html += '   </span>';
                    html += '   <button id="tarteaucitronPersonalize" class="btn-amds btn btn-primary" onclick="tarteaucitron.userInterface.openPanel();">';
                    html += '       ' + tarteaucitron.lang.personalize;
                    html += '   </button>';

                    if (tarteaucitron.parameters.privacyUrl !== "") {
                        html += '   <button id="tarteaucitronPrivacyUrl"  class="btn-amds btn btn-primary" onclick="document.location = tarteaucitron.parameters.privacyUrl">';
                        html += '       ' + tarteaucitron.lang.privacyUrl;
                        html += '   </button>';
                    }

                    html += '</div>';
                } else {
                    html += '<div id="tarteaucitronAlertBig" class="2 amds-modal container-fluid tarteaucitronAlertBig' + orientation + '">' +
                        '<div class="row m-0">';
                    html += '<div class="header">';

                    html +=`<svg class="logo_2" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="svg2" x="0px" y="0px" viewBox="0 0 1122.5 453.5" style="enable-background:new 0 0 1122.5 453.5;" xml:space="preserve">
                        <style type="text/css">
                .st0{clip-path:url(#SVGID_2_);}
                .st1{fill:#F03B26;}
                .st2{fill:#393536;}
                .st3{fill:url(#SVGID_3_2);}
                </style>
                    <g id="g10" transform="matrix(1.3333333,0,0,-1.3333333,0,453.54267)">
                        <g id="g12">
                        <g>
                        <defs>
                        <rect id="SVGID_1_" x="139" y="128.1" width="571.7" height="231"></rect>
                        </defs>
                        <clipPath id="SVGID_2_">
                        <use xlink:href="#SVGID_1_" style="overflow:visible;"></use>
                        </clipPath>
                        <g id="g14" class="st0">
                        <g id="g20" transform="translate(779.7754,198.3157)">
                        <path id="path22" class="st1" d="M-172.2,59.6c-2.2,0-4.4,0.8-5.7,1.4c-25.7,13.4-54.8,21.3-83.1,21.3c-3.5,0-6.2-0.1-9.5-0.5       c5.3-8.5,14.5-20.8,20.8-28.4c1.6-2,2.1-3.1,2.1-5c0-3.3-3.5-6.5-7.2-6.5c-2.5,0-3.9,1-6.2,3.7c-7.7,9-19.2,24.9-24.6,34       C-312.4,74.8-342.3,59-360,45c-2-1.6-3.4-2.3-5.5-2.3c-3.8,0-7,3.2-7,6.9c0,2.1,0.8,3.8,3.6,6.1c27,22.5,68.9,40.2,104.5,40.2       c14.1,0,27.7-2,40.9-5.2c8-2,19.8-5.9,29.9-10.3c-26.5,16-59.7,30.6-80.6,30.6c-5.4,0-8.6-1.8-8.6-5.4c0-2.1,1.2-5,2.9-7.8       c-4.2-0.4-9.7-1.3-13.9-2.4c-2.2,4-3.7,8.3-3.7,12.9c0,10.2,6.7,16.5,20.1,16.5c30.4,0,81.5-28.3,107-49.1       c2.9-2.4,5.8-5.3,5.8-8.8C-164.6,63.6-167.5,59.6-172.2,59.6"></path>
                        </g>
                        <g id="g24" transform="translate(130.7725,79.8913)">
                        <path id="path26" class="st2" d="M146.2,117.7c0,1.8,1.1,3,2.8,3c1.7,0,2.8-1.1,2.8-3v-3.1c1.5,3,4.8,6,7.7,6       c1.9,0,2.8-1.1,2.8-2.6c0-1.4-0.8-2.5-3.2-3.2c-5.1-1.4-7.3-4.2-7.3-9.7V89.4c0-1.8-1.1-3-2.8-3c-1.7,0-2.8,1.1-2.8,3V117.7z"></path>
                        </g>
                        <g id="g28" transform="translate(375.7041,79.8913)">
                        <path id="path30" class="st2" d="M26.1,117.7c0,1.8,1.1,3,2.8,3c1.7,0,2.8-1.1,2.8-3v-3.1c1.5,3,4.8,6,7.7,6       c1.9,0,2.8-1.1,2.8-2.6c0-1.4-0.8-2.5-3.2-3.2c-5.1-1.4-7.3-4.2-7.3-9.7V89.4c0-1.8-1.1-3-2.8-3c-1.7,0-2.8,1.1-2.8,3V117.7z"></path>
                        </g>
                        <g id="g32" transform="translate(193.4937,85.6941)">
                        <path id="path34" class="st2" d="M115.5,114.9c5.4,0,8.9-2.2,8.9-4.1c0-1.2-0.9-2.3-2.2-2.3c-2,0-3,1.6-6.7,1.6       c-6.3,0-9.6-5.7-9.6-12.3c0-7.2,3.7-12.3,9.6-12.3c4.1,0,5,1.7,7,1.7c1.3,0,2-0.8,2-2.2c0-1.3-1-2.3-2.9-3.1       c-1.6-0.8-3.8-1.2-6.1-1.2c-9.5,0-15.1,7.1-15.1,17.1C100.3,107.6,106.1,114.9,115.5,114.9"></path>
                        </g>
                        <g id="g36" transform="translate(262.8223,56.0671)">
                        <path id="path38" class="st2" d="M81.4,129.4c0,4.8-2.7,10.2-8.8,10.2c-6,0-9.2-4.7-9.4-10.2H81.4z M63.2,125.3       c0.1-5.5,3.6-10.1,9.9-10.1c6.5,0,8.1,3.7,10.4,3.7c1.3,0,2.3-0.9,2.3-2.3c0-2.7-6-6.2-12.7-6.2c-5,0-8.4,1.6-10.9,4.1       c-3.2,3.2-4.7,8-4.7,13c0,9.1,5.7,17.1,15,17.1c8.7,0,14.4-7.7,14.4-16.3c0-1.9-0.8-3-3.1-3H63.2z"></path>
                        </g>
                        <g id="g40" transform="translate(296.1406,24.3435)">
                        <path id="path42" class="st2" d="M65.1,145c0-1.8-1.1-3-2.8-3c-1.7,0-2.8,1.1-2.8,3v39.6c0,1.8,1.1,3,2.8,3       c1.7,0,2.8-1.1,2.8-3V145z"></path>
                        </g>
                        <g id="g44" transform="translate(335.9043,28.0583)">
                        <path id="path46" class="st2" d="M45.6,143.2c5.4,0,9.1,4.7,9.1,12.3c0,7.5-3.7,12.3-9.1,12.3s-9.1-4.7-9.1-12.3       C36.4,147.9,40.2,143.2,45.6,143.2 M45.6,138.3c-8.8,0-14.7,7.1-14.7,17.1c0,10.1,5.9,17.1,14.7,17.1s14.7-7.1,14.7-17.1       C60.3,145.4,54.4,138.3,45.6,138.3"></path>
                        </g>
                        <g id="g48" transform="translate(483.1455,81.1618)">
                        <path id="path50" class="st2" d="M-26.7,117.1c-3.1-10.7-8.2-28.2-8.6-29.6c-0.5-1.6-1.4-2.3-3-2.3c-1.5,0-2.5,0.6-3,2.3       c-0.4,1.5-5.8,19.9-8.8,30.4c-0.5,1.7-1,3.8-1.3,5.5c-0.2-1.7-0.5-3.7-0.8-5.6c-1.6-10-4.1-25.5-4.7-29.9       c-0.3-1.9-1.3-2.8-2.9-2.8c-1.5,0-2.5,1-2.5,2.6c0,0.6,0.1,1.4,0.3,2.5c0,0,5.6,33.6,6,36.2c0.5,2.7,1.9,4.2,4.2,4.2       c2.1,0,3.7-1.2,4.3-3.5c0.4-1.4,4.9-17.2,7.8-27.2c0.5-1.8,1.1-4,1.5-6c0.4,1.9,0.9,4,1.4,5.8c2.9,10,7.4,25.9,7.9,27.3       c0.7,2.3,2.1,3.5,4.2,3.5c2.2,0,3.8-1.4,4.2-4.2c0.4-2.6,6-36.2,6-36.2c0.2-1.1,0.3-1.9,0.3-2.5c0-1.6-1-2.6-2.5-2.6       c-1.6,0-2.6,0.8-2.9,2.8c-0.7,4.3-3,19.1-4.6,29c-0.3,2-0.6,4.3-0.9,6.5C-25.5,121.6-26,119.4-26.7,117.1"></path>
                        </g>
                        <g id="g52" transform="translate(532.3252,79.8913)">
                        <path id="path54" class="st2" d="M-50.8,117.7c0,1.8-1.1,3-2.8,3c-1.7,0-2.8-1.1-2.8-3V89.4c0-1.8,1.1-3,2.8-3       c1.7,0,2.8,1.1,2.8,3V117.7z M-53.6,130.5c1.9,0,3.4-1.5,3.4-3.4c0-1.9-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4       C-57,129-55.5,130.5-53.6,130.5"></path>
                        </g>
                        <g id="g56" transform="translate(551.3242,99.1482)">
                        <path id="path58" class="st2" d="M-60.1,108.3c0,1.8,1.1,3,2.8,3s2.8-1.1,2.8-3V101h2.3c1.8,0,2.8-0.9,2.8-2.4       c0-1.5-0.9-2.4-2.8-2.4h-2.3V70.2c0-1.8-1.1-3-2.8-3s-2.8,1.1-2.8,3v26.1h-2c-1.8,0-2.8,0.9-2.8,2.4c0,1.5,0.9,2.4,2.8,2.4h2       V108.3z"></path>
                        </g>
                        <g id="g60" transform="translate(585.7764,99.1482)">
                        <path id="path62" class="st2" d="M-77,108.3c0,1.8,1.1,3,2.8,3c1.7,0,2.8-1.1,2.8-3V101h2.3c1.8,0,2.8-0.9,2.8-2.4       c0-1.5-0.9-2.4-2.8-2.4h-2.3V70.2c0-1.8-1.1-3-2.8-3c-1.7,0-2.8,1.1-2.8,3v26.1h-2c-1.8,0-2.8,0.9-2.8,2.4       c0,1.5,0.9,2.4,2.8,2.4h2V108.3z"></path>
                        </g>
                        <g id="g64" transform="translate(68.4829,53.073)">
                        <path id="path66" class="st2" d="M176.8,130.9c2.3,6.5,4.8,13.5,6.5,18.3c0.5,1.3,0.9,2.6,1.2,3.6c0.3-1.1,0.8-2.4,1.2-3.6       c1.7-4.7,4.2-11.8,6.5-18.3H176.8z M202.6,118.4c-1.2,3.1-12,32.3-13.7,36.8c-0.8,2.3-2.1,3.6-4.3,3.6c-2.2,0-3.4-1.3-4.2-3.6       c-0.8-2-12.6-33.7-13.8-36.8c-0.5-1.4-0.7-2.1-0.7-2.7c0-1.4,1.2-2.4,2.6-2.4c1.5,0,2.4,0.8,2.8,2.1c0.3,0.8,1.8,5.1,3.8,10.6       h19c1.9-5.2,3.3-9.4,3.8-10.6c0.4-1.2,1.2-2.1,2.7-2.1c1.4,0,2.8,0.9,2.8,2.3C203.3,116.3,203.2,116.8,202.6,118.4"></path>
                        </g>
                        <g id="g68" transform="translate(695.8213,24.3435)">
                        <path id="path70" class="st2" d="M-131,145c0-1.8-1.1-3-2.8-3c-1.7,0-2.8,1.1-2.8,3v39.6c0,1.8,1.1,3,2.8,3       c1.7,0,2.8-1.1,2.8-3V145z"></path>
                        </g>
                        <g id="g72" transform="translate(640.6777,28.0437)">
                        <path id="path74" class="st2" d="M-104,143.2c-5.4,0-9.1,4.7-9.1,12.3c0,7.5,3.7,12.3,9.1,12.3c5.4,0,9.1-4.7,9.1-12.3       C-94.8,147.9-98.5,143.2-104,143.2 M-92.1,172.5c-1.7,0-2.8-1.1-2.8-3v-2.5c-2.1,3.4-5.4,5.5-9.5,5.5       c-8.5,0-14.3-7.1-14.3-17.1c0-10.1,5.8-17.1,14.3-17.1c4.1,0,7.5,2.1,9.5,5.5v-2.5c0-1.8,1.1-3,2.8-3c1.7,0,2.8,1.1,2.8,3v28.3       C-89.3,171.4-90.4,172.5-92.1,172.5"></path>
                        </g>
                        </g>
                        </g>
                        </g>
                        </g>
                        <linearGradient id="SVGID_3_2" gradientUnits="userSpaceOnUse" x1="310.0313" y1="349.0398" x2="794.6602" y2="349.0398">
                        <stop offset="0" style="stop-color:#696969"></stop>
                        <stop offset="0.6364" style="stop-color:#C74A27"></stop>
                        <stop offset="1" style="stop-color:#FF3700"></stop>
                        </linearGradient>
                        <path class="st3" d="M383.2,375.9h-59.2c0.5,9.3,3.4,17,8.9,23.2c5.4,6.1,12,9.2,19.5,9.2c3.9,0,7.9-0.6,11.8-1.9  c4-1.3,8.4-4.1,13.3-8.5c3.2-2.9,5.5-4.3,6.9-4.3c4,0,6.1,2.1,6.1,6.3c0,3.6-3.7,7.7-11.1,12.3c-7.4,4.6-16.1,6.9-26.2,6.9  c-13.5,0-24.1-4.6-31.8-13.8c-7.7-9.2-11.5-20.9-11.5-35.1c0-13.5,3.8-25,11.4-34.6c7.6-9.6,17.5-14.4,29.8-14.4  c12.4,0,22.3,4.5,29.7,13.4c7.4,8.9,11.2,20.1,11.2,33.4C392.1,373.3,389.2,375.9,383.2,375.9z M324.1,365.1h54  c-0.5-9.7-3.2-17.7-8.2-23.9c-5-6.2-11.3-9.3-18.8-9.3c-7.6,0-13.9,3.1-18.9,9.3C327.3,347.4,324.6,355.4,324.1,365.1z M410.7,364.2  h34.9c2,0,3.6,0.6,4.9,1.7c1.3,1.1,1.9,2.5,1.9,4.2c0,1.7-0.6,3.1-1.9,4.3c-1.3,1.1-2.9,1.7-4.9,1.7h-34.9c-2,0-3.6-0.6-4.9-1.7  c-1.3-1.1-1.9-2.6-1.9-4.3c0-1.6,0.6-3,1.9-4.2C407,364.8,408.7,364.2,410.7,364.2z M467.7,346.4c0-7.4,3.1-13.5,9.2-18.2  c6.1-4.7,13.1-7,20.9-7c9,0,16.8,1.6,23.6,4.7c6.8,3.1,10.2,6.5,10.2,10.1c0,4.2-2.2,6.3-6.5,6.3c-1.3,0-3.5-1.1-6.8-3.4  c-6.6-4.6-12.5-6.9-17.8-6.9c-5.2,0-9.6,1.2-13.3,3.7c-3.6,2.5-5.4,5.7-5.4,9.8c0,2.4,0.7,4.6,2.2,6.5c1.4,2,3.6,3.5,6.5,4.7l19.7,8  c9.4,3.8,15.8,7.7,19.1,11.9c3.3,4.2,4.9,9.1,4.9,14.7c0,8.2-3.3,14.9-9.9,20c-6.6,5.1-15.1,7.7-25.4,7.7c-9.4,0-17.5-2.1-24.3-6.4  c-6.8-4.2-10.2-8.2-10.2-11.8c0-1.1,0.7-2.4,2-4c1.3-1.5,2.7-2.3,4.2-2.3c1.5,0,4,1.4,7.4,4.3c4.6,3.9,8.6,6.5,11.9,7.6  c3.3,1.1,6.5,1.7,9.7,1.7c6,0,11-1.6,14.9-4.7c3.9-3.1,5.8-7,5.8-11.6c0-3.3-1-6-2.9-8.3c-1.9-2.3-5-4.2-9.2-5.9l-23.5-9.7  c-6-2.5-10.3-5.4-12.9-8.9C469,355.6,467.7,351.4,467.7,346.4z M567.7,333v77.8c0,5.5-2.1,8.3-6.4,8.3c-4.3,0-6.5-2.8-6.5-8.3V333  h-8.4c-1.8,0-3.2-0.5-4.2-1.6s-1.5-2.3-1.5-3.8c0-1.5,0.5-2.8,1.5-3.9s2.4-1.6,4.2-1.6h8.4v-21c0-5.6,2.2-8.4,6.5-8.4  c4.3,0,6.4,2.8,6.4,8.4v21h8.5c1.8,0,3.1,0.5,4.1,1.6s1.5,2.3,1.5,3.9c0,1.5-0.5,2.7-1.5,3.8s-2.3,1.6-4.1,1.6H567.7z M663.2,375.9  H604c0.5,9.3,3.4,17,8.9,23.2c5.4,6.1,12,9.2,19.5,9.2c3.9,0,7.9-0.6,11.8-1.9c4-1.3,8.4-4.1,13.3-8.5c3.2-2.9,5.5-4.3,6.9-4.3  c4,0,6.1,2.1,6.1,6.3c0,3.6-3.7,7.7-11.1,12.3c-7.4,4.6-16.1,6.9-26.2,6.9c-13.5,0-24.1-4.6-31.8-13.8c-7.7-9.2-11.5-20.9-11.5-35.1  c0-13.5,3.8-25,11.4-34.6c7.6-9.6,17.5-14.4,29.8-14.4c12.4,0,22.3,4.5,29.7,13.4c7.4,8.9,11.2,20.1,11.2,33.4  C672.1,373.3,669.1,375.9,663.2,375.9z M604,365.1h54c-0.5-9.7-3.2-17.7-8.2-23.9c-5-6.2-11.3-9.3-18.8-9.3  c-7.6,0-13.9,3.1-18.9,9.3C607.2,347.4,604.5,355.4,604,365.1z M756.6,375.9h-59.2c0.5,9.3,3.4,17,8.9,23.2c5.4,6.1,12,9.2,19.5,9.2  c3.9,0,7.9-0.6,11.8-1.9c4-1.3,8.4-4.1,13.3-8.5c3.2-2.9,5.5-4.3,6.9-4.3c4,0,6.1,2.1,6.1,6.3c0,3.6-3.7,7.7-11.1,12.3  c-7.4,4.6-16.1,6.9-26.2,6.9c-13.5,0-24.1-4.6-31.8-13.8c-7.7-9.2-11.5-20.9-11.5-35.1c0-13.5,3.8-25,11.4-34.6  c7.6-9.6,17.5-14.4,29.8-14.4c12.4,0,22.3,4.5,29.7,13.4c7.4,8.9,11.2,20.1,11.2,33.4C765.5,373.3,762.5,375.9,756.6,375.9z   M697.5,365.1h54c-0.5-9.7-3.2-17.7-8.2-23.9c-5-6.2-11.3-9.3-18.8-9.3c-7.6,0-13.9,3.1-18.9,9.3  C700.6,347.4,697.9,355.4,697.5,365.1z M794.7,287.3v123.5c0,5.5-2.2,8.3-6.5,8.3c-4.3,0-6.5-2.8-6.5-8.3V287.3  c0-5.5,2.2-8.3,6.5-8.3C792.5,279,794.7,281.8,794.7,287.3z"></path>
                        </svg>`;





                    /*      '<svg class="d-block logo col-6 44" width="119" height="50" viewBox="0 0 119 50" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
                          '<rect width="119" height="50" fill="url(#pattern0)"/>' +
                          '<defs>' +
                          '<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">' +
                          '<use xlink:href="#image0_2424_50390" transform="matrix(0.00267623 0 0 0.00636943 -0.000454959 0)"/>' +
                          '</pattern>' +
                          '<image id="image0_2424_50390" width="374" height="157" xlink:href="data:image/png;base64,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"/>' +
                          '</defs>' +
                          '</svg>';*/



                    html += ' <a id="tarteaucitronAllDenied" class=" col-6 d-block tarteaucitronDeny" onclick="tarteaucitron.userInterface.respondAll(false);">';
                    html += tarteaucitron.lang.denyAll;
                    html += '   </a></div> ';
                    html += '   <div id="tarteaucitronDisclaimerAlert">';
                    if (tarteaucitron.parameters.highPrivacy) {
                        html += '<h3 id="cookiesTitle">' + tarteaucitron.lang.alertAmdsTitle + '</h3>'
                        html += '<div>' + tarteaucitron.lang.alertBigPrivacy + '</div>';
                    } else {
                        html += '       ' + tarteaucitron.lang.alertBigClick + ' ' + tarteaucitron.lang.alertBig;
                    }

                    html += '   </div>';

                    html += '   <div class="wrapper">';
                    html += '   <button id="tarteaucitronCloseAlert" class="btn-amds btn btn-primary amds-btn-secondary" onclick="tarteaucitron.userInterface.openPanel();">';
                    html += '       <span> ' + tarteaucitron.lang.personalize;
                    html += '  </span> <svg viewBox="0 0 33 14" xmlns="http://www.w3.org/2000/svg" aria-labelledby="Long Arrow" role="presentation" class="svg-icon"><title id="Long Arrow" lang="en">Long Arrow' +
                        '                                icon</title>' +
                        '                                <polygon points="25.1604773 0 32.6352213 6.85610681 25.1993812 13.7359725 24.3690601 12.8391022 30.1441884 7.49516092 0.0024154589 7.43569437 0 6.21588761 30.2001884 6.27516092 24.3378796 0.897439017" stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd"></polygon>\n' +
                        '                            </svg></button>';
                    html += '   <button id="tarteaucitronPersonalize" class="btn-amds btn btn-primary" onclick="tarteaucitron.userInterface.respondAll(true);">';
                    html += '       <span> ' + tarteaucitron.lang.acceptAllOptions;
                    html += '  </span> <svg viewBox="0 0 33 14" xmlns="http://www.w3.org/2000/svg" aria-labelledby="Long Arrow" role="presentation" class="svg-icon"><title id="Long Arrow" lang="en">Long Arrow' +
                        '                                icon</title>' +
                        '                                <polygon points="25.1604773 0 32.6352213 6.85610681 25.1993812 13.7359725 24.3690601 12.8391022 30.1441884 7.49516092 0.0024154589 7.43569437 0 6.21588761 30.2001884 6.27516092 24.3378796 0.897439017" stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd"></polygon>\n' +
                        '                            </svg></button>';
                    html += '   </div>';
                    html += '   </br></br>';


                    if (tarteaucitron.parameters.privacyUrl !== "") {
                        html += '   <button id="tarteaucitronPrivacyUrl" onclick="document.location = tarteaucitron.parameters.privacyUrl">';
                        html += '       ' + tarteaucitron.lang.privacyUrl;
                        html += '   </button>';
                    }

                    html += '</div>';
                    html += '</div><div id="tarteaucitronPercentage"></div>';
                }

                if (tarteaucitron.parameters.showAlertSmall === true) {
                    html += '<div id="tarteaucitronAlertSmall" class="tarteaucitronAlertSmall' + orientation + '">';
                    html += '   <button id="tarteaucitronManager" onclick="tarteaucitron.userInterface.openPanel();">';
                    html += '       ' + tarteaucitron.lang.alertSmall;
                    html += '       <span id="tarteaucitronDot">';
                    html += '           <span id="tarteaucitronDotGreen"></span>';
                    html += '           <span id="tarteaucitronDotYellow"></span>';
                    html += '           <span id="tarteaucitronDotRed"></span>';
                    html += '       </span>';
                    if (tarteaucitron.parameters.cookieslist === true) {
                        html += '   </button><!-- @whitespace';
                        html += '   --><button id="tarteaucitronCookiesNumber" onclick="tarteaucitron.userInterface.toggleCookiesList();">0</button>';
                        html += '   <div id="tarteaucitronCookiesListContainer">';
                        html += '       <button id="tarteaucitronClosePanelCookie" onclick="tarteaucitron.userInterface.closePanel();">';
                        html += '           ' + tarteaucitron.lang.close;
                        html += '       </button>';
                        html += '       <div class="tarteaucitronCookiesListMain" id="tarteaucitronCookiesTitle">';
                        html += '            <span class="tarteaucitronH2" role="heading" aria-level="h2" id="tarteaucitronCookiesNumberBis">0 cookie</span>';
                        html += '       </div>';
                        html += '       <div id="tarteaucitronCookiesList"></div>';
                        html += '    </div>';
                    } else {
                        html += '   </div>';
                    }
                    html += '</div>';
                }

                tarteaucitron.addScript(tarteaucitron.cdn + 'advertising.js?v=' + tarteaucitron.version, '', function () {
                    if (tarteaucitronNoAdBlocker === true || tarteaucitron.parameters.adblocker === false) {

                        // create a wrapper container at the same level than tarteaucitron so we can add an aria-hidden when tarteaucitron is opened
                        /*var wrapper = document.createElement('div');
                        wrapper.id = "contentWrapper";

                        while (document.body.firstChild)
                        {
                            wrapper.appendChild(document.body.firstChild);
                        }

                        // Append the wrapper to the body
                        document.body.appendChild(wrapper);*/

                        div.id = 'tarteaucitronRoot';
                        body.appendChild(div, body);
                        div.innerHTML = html;

                        if (tarteaucitron.job !== undefined) {
                            //tarteaucitron.job = tarteaucitron.cleanArray(tarteaucitron.job);
                            tarteaucitron.job = tarteaucitron.job.reverse();
                            tarteaucitron.job.forEach((element) => console.log(element));

                            for (index = 0; index < tarteaucitron.job.length; index += 1) {
                                tarteaucitron.addService(tarteaucitron.job[index]);
                            }
                        } else {
                            tarteaucitron.job = []
                        }

                        tarteaucitron.isAjax = true;

                        /*tarteaucitron.job.push = function (id) {

                            // ie <9 hack
                            if (typeof tarteaucitron.job.indexOf === 'undefined') {
                                tarteaucitron.job.indexOf = function (obj, start) {
                                    var i,
                                        j = this.length;
                                    for (i = (start || 0); i < j; i += 1) {
                                        if (this[i] === obj) {
                                            return i;
                                        }
                                    }
                                    return -1;
                                };
                            }

                            if (tarteaucitron.job.indexOf(id) === -1) {
                                Array.prototype.push.call(this, id);
                            }
                            tarteaucitron.launch[id] = false;
                            tarteaucitron.addService(id);
                        };*/

                        if (document.location.hash === tarteaucitron.hashtag && tarteaucitron.hashtag !== '') {
                            tarteaucitron.userInterface.openPanel();
                        }

                        tarteaucitron.cookie.number();
                        setInterval(tarteaucitron.cookie.number, 60000);
                    }
                }, tarteaucitron.parameters.adblocker);

                if (tarteaucitron.parameters.adblocker === true) {
                    setTimeout(function () {
                        if (tarteaucitronNoAdBlocker === false) {
                            html = '<div id="tarteaucitronAlertBig" class="3 amds-modal tarteaucitronAlertBig' + orientation + '" style="display:block" role="alert" aria-live="polite">';
                            html += '   <p id="tarteaucitronDisclaimerAlert">';
                            html += '       ' + tarteaucitron.lang.adblock + '<br/>';
                            html += '       <strong>' + tarteaucitron.lang.adblock_call + '</strong>';
                            html += '   </p>';
                            html += '   <button id="tarteaucitronPersonalize" class="btn-amds btn btn-primary" onclick="location.reload();">';
                            html += '       ' + tarteaucitron.lang.reload;
                            html += '   </button>';
                            html += '</div>';
                            html += '<div id="tarteaucitronPremium"></div>';

                            // create wrapper container
                            /*var wrapper = document.createElement('div');
                            wrapper.id = "contentWrapper";

                            while (document.body.firstChild)
                            {
                                wrapper.appendChild(document.body.firstChild);
                            }

                            // Append the wrapper to the body
                            document.body.appendChild(wrapper);*/

                            div.id = 'tarteaucitronRoot';
                            body.appendChild(div, body);
                            div.innerHTML = html;
                            tarteaucitron.pro('!adblocker=true');
                        } else {
                            tarteaucitron.pro('!adblocker=false');
                        }
                    }, 1500);
                }
            });
        });

        tarteaucitron.launchSession();

        if (tarteaucitron.events.load) {
            tarteaucitron.events.load();
        }
    },
    "addService": function (serviceId) {
        "use strict";
        var html = '',
            s = tarteaucitron.services,
            service = s[serviceId],
            cookie = tarteaucitron.cookie.read(),
            hostname = document.location.hostname,
            hostRef = document.referrer.split('/')[2],
            isNavigating = (hostRef === hostname && window.location.href !== tarteaucitron.parameters.privacyUrl) ? true : false,
            isAutostart = (!service.needConsent) ? true : false,
            isWaiting = (cookie.indexOf(service.key + '=wait') >= 0) ? true : false,
            isDenied = (cookie.indexOf(service.key + '=false') >= 0) ? true : false,
            isAllowed = (cookie.indexOf(service.key + '=true') >= 0) ? true : false,
            isResponded = (cookie.indexOf(service.key + '=false') >= 0 || cookie.indexOf(service.key + '=true') >= 0) ? true : false,
            isDNTRequested = (navigator.doNotTrack === "1" || navigator.doNotTrack === "yes" || navigator.msDoNotTrack === "1" || window.doNotTrack === "1") ? true : false;


        if (document.querySelector('#tarteaucitronAlertBig').offsetLeft !== 0) {
            document.querySelector('#tarteaucitronBack').style.display = 'block'
        }

        if (tarteaucitron.added[service.key] !== true) {
            var t_name = service.name,
                t_desc = service.desc;

            if (tarteaucitron.lang.services != undefined && tarteaucitron.lang.services[service.key] != undefined) {
                t_name = tarteaucitron.lang.services[service.key].name != undefined ? tarteaucitron.lang.services[service.key].name : service.name;
                t_desc = tarteaucitron.lang.services[service.key].desc != undefined ? tarteaucitron.lang.services[service.key].desc : service.desc;
            }

            tarteaucitron.added[service.key] = true;
            html += '<li id="' + service.key + 'Line" class="tarteaucitronLine">';
            html += '   <div class="tarteaucitronName">';
            html += '     <h3 class="tarteaucitronH3" role="heading" aria-level="h3">';
            html += '       <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="8" height="8" rx="2" fill="#FF3700"/> </svg>' + t_name + '</h3>';

            if(t_desc !== '') {
                html += '       <p class="desc" role="heading">' + t_desc + '</p>';
            }

            html += '   </div>';
            html += '   <div class="tarteaucitronAsk"> <label class="switch" > <input class="askedOption" type="checkbox" id="' + service.key + '"> <span class="slider round"></span></label>';
            html += '   </div>';
            html += '</li>';

            if (document.getElementById('tarteaucitronServices_' + service.type) !== null) {
                document.getElementById('tarteaucitronServices_' + service.type).innerHTML += html;
            }

            //  tarteaucitron.userInterface.order(service.type);
        }

        // allow by default for non EU
        if (isResponded === false && tarteaucitron.user.bypass === true) {
            isAllowed = true;
            tarteaucitron.cookie.create(service.key, true);
        }

        if ((!isResponded && (isAutostart || (isNavigating && isWaiting)) && !tarteaucitron.highPrivacy) || isAllowed) {
            if (!isAllowed) {
                tarteaucitron.cookie.create(service.key, true);
            }
            if (tarteaucitron.launch[service.key] !== true) {
                tarteaucitron.launch[service.key] = true;
                service.js();
            }
            tarteaucitron.state[service.key] = true;
            tarteaucitron.userInterface.color(service.key, true);
        } else if (isDenied) {
            if (typeof service.fallback === 'function') {
                service.fallback();
            }
            tarteaucitron.state[service.key] = false;
            tarteaucitron.userInterface.color(service.key, false);
        } else if (!isResponded && isDNTRequested && tarteaucitron.handleBrowserDNTRequest) {
            tarteaucitron.cookie.create(service.key, 'false');
            if (typeof service.fallback === 'function') {
                service.fallback();
            }
            tarteaucitron.state[service.key] = false;
            tarteaucitron.userInterface.color(service.key, false);
        } else if (!isResponded) {
            tarteaucitron.cookie.create(service.key, 'wait');
            if (typeof service.fallback === 'function') {
                service.fallback();
            }
            tarteaucitron.userInterface.color(service.key, 'wait');
            tarteaucitron.userInterface.openAlert();
        }

        tarteaucitron.cookie.checkCount(service.key);
    },
    "cleanArray": function cleanArray(arr) {
        "use strict";
        var i,
            len = arr.length,
            out = [],
            obj = {},
            s = tarteaucitron.services;

        for (i = 0; i < len; i += 1) {
            if (!obj[arr[i]]) {
                obj[arr[i]] = {};
                if (tarteaucitron.services[arr[i]] !== undefined) {
                    out.push(arr[i]);
                }
            }
        }

        out = out.sort(function (a, b) {
            if (s[a].type + s[a].key > s[b].type + s[b].key) {
                return 1;
            }
            if (s[a].type + s[a].key < s[b].type + s[b].key) {
                return -1;
            }
            return 0;
        });

        return out;
    },
    "userInterface": {
        "css": function (id, property, value) {
            "use strict";
            if (document.getElementById(id) !== null) {
                document.getElementById(id).style[property] = value;
            }
        },
        "acceptAllOptions": function () {
            $(".tarteaucitronAsk input").prop("checked", true);
            setTimeout(function () {
                tarteaucitron.userInterface.respondAll(true);
                tarteaucitron.userInterface.closePanel();
            }, 500)
        },
        "acceptSelectedOptions": function () {
            var selectedOptions = $('.askedOption');
            selectedOptions.each(function( index, element ) {
                tarteaucitron.userInterface.respond(element.id, document.querySelector('#'+element.id).checked);
            });
            tarteaucitron.userInterface.closePanel();
        },

        "respondAll": function (status) {
            "use strict";
            var s = tarteaucitron.services,
                service,
                key,
                index = 0;

            for (index = 0; index < tarteaucitron.job.length; index += 1) {
                service = s[tarteaucitron.job[index]];
                key = service.key;
                if (tarteaucitron.state[key] !== status) {
                    if (status === false && tarteaucitron.launch[key] === true) {
                        tarteaucitron.reloadThePage = true;
                    }
                    if (tarteaucitron.launch[key] !== true && status === true) {
                        tarteaucitron.launch[key] = true;
                        tarteaucitron.services[key].js();
                    }
                    tarteaucitron.state[key] = status;
                    tarteaucitron.cookie.create(key, status);
                    tarteaucitron.userInterface.color(key, status);
                }
            }
            tarteaucitron.sendDefaultTag(status);
            document.querySelector('#tarteaucitronBack').style.display = 'none';
        },
        "respond": function (key, status) {
            "use strict";
            // return if same state
            if (tarteaucitron.state[key] === status) {
                return;
            }

            if (status === false && tarteaucitron.launch[key] === true) {
                tarteaucitron.reloadThePage = true;
            }

            // if not already launched... launch the service
            if (status === true) {
                if (tarteaucitron.launch[key] !== true) {
                    tarteaucitron.launch[key] = true;
                    tarteaucitron.services[key].js();
                    switch(key) {
                      case "contentsquare":
                        tarteaucitron.contentsquare = "contentsquareAllowed";
                        break;
                      case "googlemaps":
                        tarteaucitron.googlemaps = "googlemapsAllowed";
                        break;
                      case "googletagmanager":
                        tarteaucitron.googletagmanager = "googletagmanagerAllowed";
                        break;
                      case "googleadwordsremarketing":
                        tarteaucitron.googleadwordsremarketing = "googleadwordsremarketingAllowed";
                        break;
                      default:
                        break;
                    }
                }
            } else {
              switch(key) {
                   case "contentsquare":
                     tarteaucitron.contentsquare = "contentsquareDenied";
                     break;
                   case "googlemaps":
                     tarteaucitron.googlemaps = "googlemapsDenied";
                     break;
                   case "googletagmanager":
                     tarteaucitron.googletagmanager = "googletagmanagerDenied";
                     break;
                   case "googleadwordsremarketing":
                     tarteaucitron.googleadwordsremarketing = "googleadwordsremarketingDenied";
                     break;
                   default:
                     break;
                 }
            }

            tarteaucitron.state[key] = status;
            tarteaucitron.cookie.create(key, status);
            tarteaucitron.userInterface.color(key, status);
        },
        "color": function (key, status) {
            "use strict";
            var gray = '#b0b1b5',
                greenDark = '#ff3700',
                greenLight = '#ff3700',
                redDark = '#696969',
                redLight = '#696969',
                yellowDark = '#FBDA26',
                c = 'tarteaucitron',
                nbDenied = 0,
                nbPending = 0,
                nbAllowed = 0,
                sum = tarteaucitron.job.length,
                index;

            // check if all services are allowed
            for (index = 0; index < sum; index += 1) {
                if (tarteaucitron.state[tarteaucitron.job[index]] === false) {
                    nbDenied += 1;
                } else if (tarteaucitron.state[tarteaucitron.job[index]] === undefined) {
                    nbPending += 1;
                } else if (tarteaucitron.state[tarteaucitron.job[index]] === true) {
                    nbAllowed += 1;
                }
            }

            tarteaucitron.userInterface.css(c + 'DotGreen', 'width', ((100 / sum) * nbAllowed) + '%');
            tarteaucitron.userInterface.css(c + 'DotYellow', 'width', ((100 / sum) * nbPending) + '%');
            tarteaucitron.userInterface.css(c + 'DotRed', 'width', ((100 / sum) * nbDenied) + '%');

            if (nbDenied === 0 && nbPending === 0) {
                tarteaucitron.userInterface.css(c + 'AllAllowed', 'backgroundColor', greenDark);
                tarteaucitron.userInterface.css(c + 'AllDenied', 'opacity', '0.4');
                tarteaucitron.userInterface.css(c + 'AllAllowed', 'opacity', '1');
            } else if (nbAllowed === 0 && nbPending === 0) {
                tarteaucitron.userInterface.css(c + 'AllAllowed', 'opacity', '0.4');
                tarteaucitron.userInterface.css(c + 'AllDenied', 'opacity', '1');
                tarteaucitron.userInterface.css(c + 'AllDenied', 'backgroundColor', redDark);
            } else {
                tarteaucitron.userInterface.css(c + 'AllAllowed', 'opacity', '0.4');
                tarteaucitron.userInterface.css(c + 'AllDenied', 'opacity', '0.4');
            }

            // close the alert if all service have been reviewed
            if (nbPending === 0) {
                tarteaucitron.userInterface.closeAlert();
            }

            if (tarteaucitron.services[key].cookies.length > 0 && status === false) {
                tarteaucitron.cookie.purge(tarteaucitron.services[key].cookies);
            }

            if (status === true) {
                if (document.getElementById('tacCL' + key) !== null) {
                    document.getElementById('tacCL' + key).innerHTML = '...';
                }
                setTimeout(function () {
                    tarteaucitron.cookie.checkCount(key);
                }, 2500);
            } else {
                tarteaucitron.cookie.checkCount(key);
            }

            if (status == true) {
                $("#"+key).attr('checked', true)
            }
        },
        "openPanel": function () {
            "use strict";


            tarteaucitron.userInterface.css('tarteaucitronAlertBig', 'display', 'none');
            tarteaucitron.userInterface.css('tarteaucitron', 'display', 'block');
            tarteaucitron.userInterface.css('tarteaucitronBack', 'display', 'block');
            tarteaucitron.userInterface.css('tarteaucitronCookiesListContainer', 'display', 'none');

            //document.getElementById('tarteaucitronClosePanel').focus();
            //document.getElementById('contentWrapper').setAttribute("aria-hidden", "true");
            //document.getElementsByTagName('body')[0].classList.add('modal-open');
            tarteaucitron.userInterface.focusTrap();
            tarteaucitron.userInterface.jsSizing('main');

        },
        "closePanel": function () {
            "use strict";

            if (document.location.hash === tarteaucitron.hashtag) {
                document.location.hash = '';
            }
            tarteaucitron.userInterface.css('tarteaucitron', 'display', 'none');
            tarteaucitron.userInterface.css('tarteaucitronCookiesListContainer', 'display', 'none');

            tarteaucitron.fallback(['tarteaucitronInfoBox'], function (elem) {
                elem.style.display = 'none';
            }, true);

            if (tarteaucitron.reloadThePage === true) {
                window.location.reload();
            } else {
                tarteaucitron.userInterface.css('tarteaucitronBack', 'display', 'none');
            }
            if (document.getElementById('tarteaucitronCloseAlert') !== null) {
                document.getElementById('tarteaucitronCloseAlert').focus();
            }
            //document.getElementById('contentWrapper').setAttribute("aria-hidden", "false");
            //document.getElementsByTagName('body')[0].classList.remove('modal-open');

            tarteaucitron.sendConfiguredTags();

        },
        "focusTrap": function () {
            "use strict";

            var focusableEls,
                firstFocusableEl,
                lastFocusableEl,
                filtered;

            focusableEls = document.getElementById('tarteaucitron').querySelectorAll('a[href], button');
            filtered = [];

            // get only visible items
            for (var i = 0, max = focusableEls.length; i < max; i++) {
                if (focusableEls[i].offsetHeight > 0) {
                    filtered.push(focusableEls[i]);
                }
            }

            firstFocusableEl = filtered[0];
            lastFocusableEl = filtered[filtered.length - 1];

            //loop focus inside tarteaucitron
            document.getElementById('tarteaucitron').addEventListener("keydown", function (evt) {

                if (evt.key === 'Tab' || evt.keyCode === 9) {

                    if (evt.shiftKey) /* shift + tab */ {
                        if (document.activeElement === firstFocusableEl) {
                            lastFocusableEl.focus();
                            evt.preventDefault();
                        }
                    } else /* tab */ {
                        if (document.activeElement === lastFocusableEl) {
                            firstFocusableEl.focus();
                            evt.preventDefault();
                        }
                    }
                }
            })
        },
        "openAlert": function () {
            "use strict";
            var c = 'tarteaucitron';
            tarteaucitron.userInterface.css(c + 'Percentage', 'display', 'block');
            tarteaucitron.userInterface.css(c + 'AlertSmall', 'display', 'none');
            tarteaucitron.userInterface.css(c + 'AlertBig', 'display', 'block');
        },
        "closeAlert": function () {
            "use strict";
            var c = 'tarteaucitron';
            tarteaucitron.userInterface.css(c + 'Percentage', 'display', 'none');
            tarteaucitron.userInterface.css(c + 'AlertSmall', 'display', 'block');
            tarteaucitron.userInterface.css(c + 'AlertBig', 'display', 'none');
            tarteaucitron.userInterface.jsSizing('box');
        },
        "toggleCookiesList": function () {
            "use strict";
            var div = document.getElementById('tarteaucitronCookiesListContainer');

            if (div === null) {
                return;
            }

            if (div.style.display !== 'block') {
                tarteaucitron.cookie.number();
                div.style.display = 'block';
                tarteaucitron.userInterface.jsSizing('cookie');
                tarteaucitron.userInterface.css('tarteaucitron', 'display', 'none');
                tarteaucitron.userInterface.css('tarteaucitronBack', 'display', 'block');
                tarteaucitron.fallback(['tarteaucitronInfoBox'], function (elem) {
                    elem.style.display = 'none';
                }, true);
            } else {
                div.style.display = 'none';
                tarteaucitron.userInterface.css('tarteaucitron', 'display', 'none');
                tarteaucitron.userInterface.css('tarteaucitronBack', 'display', 'none');
            }
        },
        "toggle": function (id, closeClass) {
            "use strict";
            var div = document.getElementById(id);

            if (div === null) {
                return;
            }

            if (closeClass !== undefined) {
                tarteaucitron.fallback([closeClass], function (elem) {
                    if (elem.id !== id) {
                        elem.style.display = 'none';
                    }
                }, true);
            }

            if (div.style.display !== 'block') {
                div.style.display = 'block';
            } else {
                div.style.display = 'none';
            }
        },
        "order": function (id) {
            "use strict";
            var main = document.getElementById('tarteaucitronServices_' + id),
                allDivs,
                store = [],
                i;

            if (main === null) {
                return;
            }

            allDivs = main.childNodes;

            if (typeof Array.prototype.map === 'function') {
                Array.prototype.map.call(main.children, Object).sort(function (a, b) {
                    //var mainChildren = Array.from(main.children);
                    //mainChildren.sort(function (a, b) {
                    if (tarteaucitron.services[a.id.replace(/Line/g, '')].name > tarteaucitron.services[b.id.replace(/Line/g, '')].name) {
                        return 1;
                    }
                    if (tarteaucitron.services[a.id.replace(/Line/g, '')].name < tarteaucitron.services[b.id.replace(/Line/g, '')].name) {
                        return -1;
                    }
                    return 0;
                }).forEach(function (element) {
                    main.appendChild(element);
                });
            }
        },
        "jsSizing": function (type) {
            "use strict";
            var scrollbarMarginRight = 10,
                scrollbarWidthParent,
                scrollbarWidthChild,
                servicesHeight,
                e = window,
                a = 'inner',
                windowInnerHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
                mainTop,
                mainHeight,
                closeButtonHeight,
                headerHeight,
                cookiesListHeight,
                cookiesCloseHeight,
                cookiesTitleHeight,
                paddingBox,
                alertSmallHeight,
                cookiesNumberHeight;

            if (type === 'box') {
                if (document.getElementById('tarteaucitronAlertSmall') !== null && document.getElementById('tarteaucitronCookiesNumber') !== null) {

                    // reset
                    tarteaucitron.userInterface.css('tarteaucitronCookiesNumber', 'padding', '0px 10px');

                    // calculate
                    alertSmallHeight = document.getElementById('tarteaucitronAlertSmall').offsetHeight;
                    cookiesNumberHeight = document.getElementById('tarteaucitronCookiesNumber').offsetHeight;
                    paddingBox = (alertSmallHeight - cookiesNumberHeight) / 2;

                    // apply
                    tarteaucitron.userInterface.css('tarteaucitronCookiesNumber', 'padding', paddingBox + 'px 10px');
                }
            } else if (type === 'main') {

                // get the real window width for media query
                if (window.innerWidth === undefined) {
                    a = 'client';
                    e = document.documentElement || document.body;
                }

                // height of the services list container
                if (document.getElementById('tarteaucitron') !== null && document.getElementById('tarteaucitronClosePanel') !== null && document.getElementById('tarteaucitronMainLineOffset') !== null) {

                    // reset
                    tarteaucitron.userInterface.css('tarteaucitronServices', 'height', 'auto');

                    // calculate
                    mainHeight = document.getElementById('tarteaucitron').offsetHeight;
                    closeButtonHeight = document.getElementById('tarteaucitronClosePanel').offsetHeight;

                    // apply
                    servicesHeight = (mainHeight - closeButtonHeight + 2);
                    tarteaucitron.userInterface.css('tarteaucitronServices', 'height', servicesHeight + 'px');
                    tarteaucitron.userInterface.css('tarteaucitronServices', 'overflow-x', 'auto');
                }

                // align the main allow/deny button depending on scrollbar width
                if (document.getElementById('tarteaucitronServices') !== null && document.getElementById('tarteaucitronScrollbarChild') !== null) {

                    // media query
                    if (e[a + 'Width'] <= 479) {
                        tarteaucitron.userInterface.css('tarteaucitronScrollbarAdjust', 'marginLeft', '11px');
                    } else if (e[a + 'Width'] <= 767) {
                        scrollbarMarginRight = 12;
                    }

                    scrollbarWidthParent = document.getElementById('tarteaucitronServices').offsetWidth;
                    scrollbarWidthChild = document.getElementById('tarteaucitronScrollbarChild').offsetWidth;
                    tarteaucitron.userInterface.css('tarteaucitronScrollbarAdjust', 'marginRight', ((scrollbarWidthParent - scrollbarWidthChild) + scrollbarMarginRight) + 'px');
                }

                // center the main panel
                if (document.getElementById('tarteaucitron') !== null) {

                    // media query
                    if (e[a + 'Width'] <= 767) {
                        mainTop = 0;
                    } else {
                        mainTop = ((windowInnerHeight - document.getElementById('tarteaucitron').offsetHeight) / 2) - 21;
                    }

                    // correct
                    if (mainTop < 0) {
                        mainTop = 0;
                    }

                    if (document.getElementById('tarteaucitronMainLineOffset') !== null) {
                        if (document.getElementById('tarteaucitron').offsetHeight < (windowInnerHeight / 2)) {
                            mainTop -= document.getElementById('tarteaucitronMainLineOffset').offsetHeight;
                        }
                    }

                    // apply
                    //   tarteaucitron.userInterface.css('tarteaucitron', 'top', mainTop + 'px');
                }


            } else if (type === 'cookie') {

                // put cookies list at bottom
                if (document.getElementById('tarteaucitronAlertSmall') !== null) {
                    tarteaucitron.userInterface.css('tarteaucitronCookiesListContainer', 'bottom', (document.getElementById('tarteaucitronAlertSmall').offsetHeight) + 'px');
                }

                // height of cookies list
                if (document.getElementById('tarteaucitronCookiesListContainer') !== null) {

                    // reset
                    tarteaucitron.userInterface.css('tarteaucitronCookiesList', 'height', 'auto');

                    // calculate
                    cookiesListHeight = document.getElementById('tarteaucitronCookiesListContainer').offsetHeight;
                    cookiesCloseHeight = document.getElementById('tarteaucitronClosePanelCookie').offsetHeight;
                    cookiesTitleHeight = document.getElementById('tarteaucitronCookiesTitle').offsetHeight;

                    // apply
                    tarteaucitron.userInterface.css('tarteaucitronCookiesList', 'height', (cookiesListHeight - cookiesCloseHeight - cookiesTitleHeight - 2) + 'px');
                }
            }
        }
    },
    "cookie": {
        "owner": {},
        "create": function (key, status) {
            "use strict";

            if (tarteaucitronForceExpire !== '') {
                // The number of day cann't be higher than 1 year
                timeExipre = (tarteaucitronForceExpire > 365) ? 31536000000 : tarteaucitronForceExpire * 86400000; // Multiplication to tranform the number of days to milliseconds
            }

            var d = new Date(),
                time = d.getTime(),
                expireTime = time + timeExipre, // 365 days
                regex = new RegExp("!" + key + "=(wait|true|false)", "g"),
                cookie = tarteaucitron.cookie.read().replace(regex, ""),
                value = tarteaucitron.parameters.cookieName + '=' + cookie + '!' + key + '=' + status,
                domain = (tarteaucitron.parameters.cookieDomain !== undefined && tarteaucitron.parameters.cookieDomain !== '') ? 'domain=' + tarteaucitron.parameters.cookieDomain + ';' : '';

            if (tarteaucitron.cookie.read().indexOf(key + '=' + status) === -1) {
                tarteaucitron.pro('!' + key + '=' + status);
            }

            d.setTime(expireTime);
            document.cookie = value + '; expires=' + d.toGMTString() + '; path=/;' + domain;
        },
        "read": function () {
            "use strict";
            var nameEQ = tarteaucitron.parameters.cookieName + "=",
                ca = document.cookie.split(';'),
                i,
                c;

            for (i = 0; i < ca.length; i += 1) {
                c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1, c.length);
                }
                if (c.indexOf(nameEQ) === 0) {
                    return c.substring(nameEQ.length, c.length);
                }
            }
            return '';
        },
        "purge": function (arr) {
            "use strict";
            var i;

            for (i = 0; i < arr.length; i += 1) {
                document.cookie = arr[i] + '=; expires=Thu, 01 Jan 2000 00:00:00 GMT; path=/;';
                document.cookie = arr[i] + '=; expires=Thu, 01 Jan 2000 00:00:00 GMT; path=/; domain=.' + location.hostname + ';';
                document.cookie = arr[i] + '=; expires=Thu, 01 Jan 2000 00:00:00 GMT; path=/; domain=.' + location.hostname.split('.').slice(-2).join('.') + ';';
            }
        },
        "checkCount": function (key) {
            "use strict";
            var arr = tarteaucitron.services[key].cookies,
                nb = arr.length,
                nbCurrent = 0,
                html = '',
                i,
                status = document.cookie.indexOf(key + '=true');

            if (status >= 0 && nb === 0) {
                html += tarteaucitron.lang.useNoCookie;
            } else if (status >= 0) {
                for (i = 0; i < nb; i += 1) {
                    if (document.cookie.indexOf(arr[i] + '=') !== -1) {
                        nbCurrent += 1;
                        if (tarteaucitron.cookie.owner[arr[i]] === undefined) {
                            tarteaucitron.cookie.owner[arr[i]] = [];
                        }
                        if (tarteaucitron.cookie.crossIndexOf(tarteaucitron.cookie.owner[arr[i]], tarteaucitron.services[key].name) === false) {
                            tarteaucitron.cookie.owner[arr[i]].push(tarteaucitron.services[key].name);
                        }
                    }
                }

                if (nbCurrent > 0) {
                    html += tarteaucitron.lang.useCookieCurrent + ' ' + nbCurrent + ' cookie';
                    if (nbCurrent > 1) {
                        html += 's';
                    }
                    html += '.';
                } else {
                    html += tarteaucitron.lang.useNoCookie;
                }
            } else if (nb === 0) {
                html = tarteaucitron.lang.noCookie;
            } else {
                html += tarteaucitron.lang.useCookie + ' ' + nb + ' cookie';
                if (nb > 1) {
                    html += 's';
                }
                html += '.';
            }

            if (document.getElementById('tacCL' + key) !== null) {
                document.getElementById('tacCL' + key).innerHTML = html;
            }
        },
        "crossIndexOf": function (arr, match) {
            "use strict";
            var i;
            for (i = 0; i < arr.length; i += 1) {
                if (arr[i] === match) {
                    return true;
                }
            }
            return false;
        },
        "number": function () {
            "use strict";
            var cookies = document.cookie.split(';'),
                nb = (document.cookie !== '') ? cookies.length : 0,
                html = '',
                i,
                name,
                namea,
                nameb,
                c,
                d,
                s = (nb > 1) ? 's' : '',
                savedname,
                regex = /^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i,
                regexedDomain = (tarteaucitron.cdn.match(regex) !== null) ? tarteaucitron.cdn.match(regex)[1] : tarteaucitron.cdn,
                host = (tarteaucitron.domain !== undefined) ? tarteaucitron.domain : regexedDomain;

            cookies = cookies.sort(function (a, b) {
                namea = a.split('=', 1).toString().replace(/ /g, '');
                nameb = b.split('=', 1).toString().replace(/ /g, '');
                c = (tarteaucitron.cookie.owner[namea] !== undefined) ? tarteaucitron.cookie.owner[namea] : '0';
                d = (tarteaucitron.cookie.owner[nameb] !== undefined) ? tarteaucitron.cookie.owner[nameb] : '0';
                if (c + a > d + b) {
                    return 1;
                }
                if (c + a < d + b) {
                    return -1;
                }
                return 0;
            });

            if (document.cookie !== '') {
                for (i = 0; i < nb; i += 1) {
                    name = cookies[i].split('=', 1).toString().replace(/ /g, '');
                    if (tarteaucitron.cookie.owner[name] !== undefined && tarteaucitron.cookie.owner[name].join(' // ') !== savedname) {
                        savedname = tarteaucitron.cookie.owner[name].join(' // ');
                        html += '<div class="tarteaucitronHidden">';
                        html += '     <span class="tarteaucitronTitle tarteaucitronH3" role="heading" aria-level="h3">';
                        html += '        ' + tarteaucitron.cookie.owner[name].join(' // ');
                        html += '    </span>';
                        html += '</div><ul class="cookie-list">';
                    } else if (tarteaucitron.cookie.owner[name] === undefined && host !== savedname) {
                        savedname = host;
                        html += '<div class="tarteaucitronHidden">';
                        html += '     <span class="tarteaucitronTitle tarteaucitronH3" role="heading" aria-level="h3">';
                        html += '        ' + host;
                        html += '    </span>';
                        html += '</div><ul class="cookie-list">';
                    }
                    html += '<li class="tarteaucitronCookiesListMain">';
                    html += '    <div class="tarteaucitronCookiesListLeft"><button onclick="tarteaucitron.cookie.purge([\'' + cookies[i].split('=', 1) + '\']);tarteaucitron.cookie.number();tarteaucitron.userInterface.jsSizing(\'cookie\');return false"><strong>&times;</strong></button> <strong>' + name + '</strong>';
                    html += '    </div>';
                    html += '    <div class="tarteaucitronCookiesListRight">' + cookies[i].split('=').slice(1).join('=') + '</div>';
                    html += '</li>';
                }
                html += '</ul>';
            } else {
                html += '<div class="tarteaucitronCookiesListMain">';
                html += '    <div class="tarteaucitronCookiesListLeft"><strong>-</strong></div>';
                html += '    <div class="tarteaucitronCookiesListRight"></div>';
                html += '</div>';
            }

            html += '<div class="tarteaucitronHidden"></div>';

            if (document.getElementById('tarteaucitronCookiesList') !== null) {
                document.getElementById('tarteaucitronCookiesList').innerHTML = html;
            }

            if (document.getElementById('tarteaucitronCookiesNumber') !== null) {
                document.getElementById('tarteaucitronCookiesNumber').innerHTML = nb;
            }

            if (document.getElementById('tarteaucitronCookiesNumberBis') !== null) {
                document.getElementById('tarteaucitronCookiesNumberBis').innerHTML = nb + ' cookie' + s;
            }

            for (i = 0; i < tarteaucitron.job.length; i += 1) {
                tarteaucitron.cookie.checkCount(tarteaucitron.job[i]);
            }
        }
    },
    "getLanguage": function () {
        "use strict";
        if (!navigator) {
            return 'en';
        }

        var availableLanguages = 'cs,en,fr,es,it,de,nl,pt,pl,ru,el',
            defaultLanguage = 'en',
            lang = navigator.language || navigator.browserLanguage ||
                navigator.systemLanguage || navigator.userLang || null,
            userLanguage = lang.substr(0, 2);

        if (tarteaucitronForceLanguage !== '') {
            if (availableLanguages.indexOf(tarteaucitronForceLanguage) !== -1) {
                return tarteaucitronForceLanguage;
            }
        }

        if (availableLanguages.indexOf(userLanguage) === -1) {
            return defaultLanguage;
        }
        return userLanguage;
    },
    "getLocale": function () {
        "use strict";
        if (!navigator) {
            return 'en_US';
        }

        var lang = navigator.language || navigator.browserLanguage ||
            navigator.systemLanguage || navigator.userLang || null,
            userLanguage = lang.substr(0, 2);

        if (userLanguage === 'fr') {
            return 'fr_FR';
        } else if (userLanguage === 'en') {
            return 'en_US';
        } else if (userLanguage === 'de') {
            return 'de_DE';
        } else if (userLanguage === 'es') {
            return 'es_ES';
        } else if (userLanguage === 'it') {
            return 'it_IT';
        } else if (userLanguage === 'pt') {
            return 'pt_PT';
        } else if (userLanguage === 'nl') {
            return 'nl_NL';
        } else if (userLanguage === 'el') {
            return 'el_EL';
        } else {
            return 'en_US';
        }
    },
    "addScript": function (url, id, callback, execute, attrName, attrVal) {
        "use strict";
        var script,
            done = false;

        if (execute === false) {
            if (typeof callback === 'function') {
                callback();
            }
        } else {
            script = document.createElement('script');
            script.type = 'text/javascript';
            script.id = (id !== undefined) ? id : '';
            script.async = true;
            script.src = url;

            if (attrName !== undefined && attrVal !== undefined) {
                script.setAttribute(attrName, attrVal);
            }

            if (typeof callback === 'function') {
                script.onreadystatechange = script.onload = function () {
                    var state = script.readyState;
                    if (!done && (!state || /loaded|complete/.test(state))) {
                        done = true;
                        callback();
                    }
                };
            }

            document.getElementsByTagName('head')[0].appendChild(script);
        }
    },
    "makeAsync": {
        "antiGhost": 0,
        "buffer": '',
        "init": function (url, id) {
            "use strict";
            var savedWrite = document.write,
                savedWriteln = document.writeln;

            document.write = function (content) {
                tarteaucitron.makeAsync.buffer += content;
            };
            document.writeln = function (content) {
                tarteaucitron.makeAsync.buffer += content.concat("\n");
            };

            setTimeout(function () {
                document.write = savedWrite;
                document.writeln = savedWriteln;
            }, 20000);

            tarteaucitron.makeAsync.getAndParse(url, id);
        },
        "getAndParse": function (url, id) {
            "use strict";
            if (tarteaucitron.makeAsync.antiGhost > 9) {
                tarteaucitron.makeAsync.antiGhost = 0;
                return;
            }
            tarteaucitron.makeAsync.antiGhost += 1;
            tarteaucitron.addScript(url, '', function () {
                if (document.getElementById(id) !== null) {
                    document.getElementById(id).innerHTML += "<span style='display:none'>&nbsp;</span>" + tarteaucitron.makeAsync.buffer;
                    tarteaucitron.makeAsync.buffer = '';
                    tarteaucitron.makeAsync.execJS(id);
                }
            });
        },
        "execJS": function (id) {
            /* not strict because third party scripts may have errors */
            var i,
                scripts,
                childId,
                type;

            if (document.getElementById(id) === null) {
                return;
            }

            scripts = document.getElementById(id).getElementsByTagName('script');
            for (i = 0; i < scripts.length; i += 1) {
                type = (scripts[i].getAttribute('type') !== null) ? scripts[i].getAttribute('type') : '';
                if (type === '') {
                    type = (scripts[i].getAttribute('language') !== null) ? scripts[i].getAttribute('language') : '';
                }
                if (scripts[i].getAttribute('src') !== null && scripts[i].getAttribute('src') !== '') {
                    childId = id + Math.floor(Math.random() * 99999999999);
                    document.getElementById(id).innerHTML += '<div id="' + childId + '"></div>';
                    tarteaucitron.makeAsync.getAndParse(scripts[i].getAttribute('src'), childId);
                } else if (type.indexOf('javascript') !== -1 || type === '') {
                    eval(scripts[i].innerHTML);
                }
            }
        }
    },
    "fallback": function (matchClass, content, noInner) {
        "use strict";
        var elems = document.getElementsByTagName('*'),
            i,
            index = 0;

        for (i in elems) {
            if (elems[i] !== undefined) {
                for (index = 0; index < matchClass.length; index += 1) {
                    if ((' ' + elems[i].className + ' ')
                        .indexOf(' ' + matchClass[index] + ' ') > -1) {
                        if (typeof content === 'function') {
                            if (noInner === true) {
                                content(elems[i]);
                            } else {
                                elems[i].innerHTML = content(elems[i]);
                            }
                        } else {
                            elems[i].innerHTML = content;
                        }
                    }
                }
            }
        }
    },
    "engage": function (id) {
        "use strict";
        var html = '',
            r = Math.floor(Math.random() * 100000),
            engage = tarteaucitron.services[id].name + ' ' + tarteaucitron.lang.fallback;

        if (tarteaucitron.lang['engage-' + id] !== undefined) {
            engage = tarteaucitron.lang['engage-' + id];
        }

        html += '<div class="tac_activate">';
        html += '   <div class="tac_float">';
        html += '      ' + engage;
        html += '      <button class="tarteaucitronAllow" id="Eng' + r + 'ed' + id + '" onclick="tarteaucitron.userInterface.respond(this, true);">';
        html += '          &#10003; ' + tarteaucitron.lang.allow;
        html += '       </button>';
        html += '   </div>';
        html += '</div>';

        return html;
    },
    "extend": function (a, b) {
        "use strict";
        var prop;
        for (prop in b) {
            if (b.hasOwnProperty(prop)) {
                a[prop] = b[prop];
            }
        }
    },
    "proTemp": '',
    "proTimer": function () {
        "use strict";
        setTimeout(tarteaucitron.proPing, 1000);
    },
    "pro": function (list) {
        "use strict";
        tarteaucitron.proTemp += list;
        clearTimeout(tarteaucitron.proTimer);
        tarteaucitron.proTimer = setTimeout(tarteaucitron.proPing, 2500);
    },
    "proPing": function () {
        "use strict";
        if (tarteaucitron.uuid !== '' && tarteaucitron.uuid !== undefined && tarteaucitron.proTemp !== '') {
            var div = document.getElementById('tarteaucitronPremium'),
                timestamp = new Date().getTime(),
                url = '//opt-out.ferank.eu/premium.php?';

            if (div === null) {
                return;
            }

            url += 'domain=' + tarteaucitron.domain + '&';
            url += 'uuid=' + tarteaucitron.uuid + '&';
            url += 'c=' + encodeURIComponent(tarteaucitron.proTemp) + '&';
            url += '_' + timestamp;

            div.innerHTML = '<img src="' + url + '" style="display:none" />';

            tarteaucitron.proTemp = '';
        }

        tarteaucitron.cookie.number();
    },
    "AddOrUpdate": function (source, custom) {
        /**
         Utility function to Add or update the fields of obj1 with the ones in obj2
         */
        for (key in custom) {
            if (custom[key] instanceof Object) {
                source[key] = tarteaucitron.AddOrUpdate(source[key], custom[key]);
            } else {
                source[key] = custom[key];
            }
        }
        return source;
    },
    "getElemWidth": function (elem) {
        return elem.getAttribute('width') || elem.clientWidth;
    },
    "getElemHeight": function (elem) {
        return elem.getAttribute('height') || elem.clientHeight;
    },

    "sendDefaultTag": function (status) {
        $.ajax({
            url: ACC.config.encodedContextPath + "/tlog",
            method: "POST",
            dataType: 'json',
            traditional: true,
            data: {
                "tags": tarteaucitron.getDefaultTags(status),
            },
            success: function (response) {
                console.log(response);
            },
        });
        ACC.config.noReponse = false;
    },

    "sendConfiguredTags": function () {
        $.ajax({
            url: ACC.config.encodedContextPath + "/tlog",
            method: "POST",
            dataType: 'json',
            traditional: true,
            data: {
                "tags": tarteaucitron.pushTags(),
            },
            success: function (response) {
                console.log(response);
            },

        });
        ACC.config.noReponse = false;
    },


    "pushTags": function () {
        var tags = [];

        tags.push(tarteaucitron.contentsquare, tarteaucitron.googlemaps, tarteaucitron.googletagmanager, tarteaucitron.googleadwordsremarketing);

        return tags;
    },

    "getDefaultTags": function (status) {
        if (status) {
            return ["all accepted"];
        } else {
            return ["all refused"];
        }
        ;
    },

    "launchSession": function () {

        $.ajax({
            url: ACC.config.encodedContextPath + "/tlog",
            method: "POST",
            dataType: 'json',
            traditional: true,
            data: {
                "tags": ["no-reponse"],
            },
            success: function (response) {
                console.log(response);
            },
        });

    }


};
